import { useState } from 'react';
import ResetPassword from '@auth0/auth0-acul-js/reset-password';

const ResetPasswordScreen = () => {
    const [password, setPassword] = useState('');
    const [reEnterPassword, setReEnterPassword] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);

    const resetPasswordManager = new ResetPassword();
    const handleResetPassword = async (e:any) => {
        e.preventDefault();
        setError('');
        setSuccess(false);

        if (password !== reEnterPassword) {
            setError('Passwords do not match. Please try again.');
            return;
        }

        try {
            const result = await resetPasswordManager.resetPassword({
                'password-reset': password,
                're-enter-password': reEnterPassword,
            }).catch((err:any) => {
                console.log(err);
                setError('Failed to reset password. Please try again later.');
            });
            resetPasswordManager.transaction.errors
            console.log(result)
            setSuccess(true);
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
        } catch (error:any) {
            setError('Failed to reset password. Please try again later.');
        }
    };

    return (
        <div className="min-h-screen bg-gray-100 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
            <div className="sm:mx-auto sm:w-full sm:max-w-md">
                <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
                    Reset your password
                </h2>
            </div>

            <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
                <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
                    <form className="space-y-6" onSubmit={handleResetPassword}>
                        <div>
                            <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                                New Password
                            </label>
                            <div className="mt-1">
                                <input
                                    id="password"
                                    name="password"
                                    type="password"
                                    required
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                                />
                            </div>
                        </div>

                        <div>
                            <label htmlFor="re-enter-password" className="block text-sm font-medium text-gray-700">
                                Re-enter Password
                            </label>
                            <div className="mt-1">
                                <input
                                    id="re-enter-password"
                                    name="re-enter-password"
                                    type="password"
                                    required
                                    value={reEnterPassword}
                                    onChange={(e) => setReEnterPassword(e.target.value)}
                                    className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                                />
                            </div>
                        </div>

                        {error && (
                            <div className="text-red-600 text-sm">
                                {error}
                            </div>
                        )}

                        {success && (
                            <div className="text-green-600 text-sm">
                                Password reset successful! You can now log in with your new password.
                            </div>
                        )}

                        <div>
                            <button
                                type="submit"
                                className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                            >
                                Reset Password
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default ResetPasswordScreen;